import { createFileRoute } from '@tanstack/react-router'
import { MailTemplatesPage } from '@/pages/mails-templates/MailTemplatesPage'

export const Route = createFileRoute('/_private/templates/')({
    component: MailTemplatesPage,
})
